import { useTranslation } from 'react-i18next';
import { GrossPrice } from '@/components/billing/PricingBreakdown';
import type { PricingDisplayContract } from '@/lib/billing/pricingDisplay';
import { formatLocalizedDate } from '@/lib/localizedDate';

export function DowngradePricingSummary({
  targetPlan,
  effectiveDate,
  renewalPricing,
}: {
  targetPlan: string;
  effectiveDate: string | null | undefined;
  renewalPricing: PricingDisplayContract | null | undefined;
}) {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? i18n.language;
  const formattedDate = effectiveDate
    ? formatLocalizedDate(effectiveDate, 'MMM dd, yyyy', language)
    : t('common.notAvailable');

  return (
    <div className="space-y-3 rounded-lg border border-border p-4 text-sm" data-testid="downgrade-pricing-summary">
      <div>
        <span className="block text-xs text-muted-foreground">{t('commercialPlanChange.fields.targetValue')}</span>
        <span className="font-semibold text-foreground">{targetPlan}</span>
      </div>
      <div>
        <span className="block text-xs text-muted-foreground">{t('commercialPlanChange.fields.renewalDate')}</span>
        <span className="font-semibold text-foreground">{formattedDate}</span>
      </div>
      <div>
        <span className="block text-xs text-muted-foreground">{t('commercialPlanChange.fields.nextRenewal')}</span>
        {renewalPricing
          ? <GrossPrice pricing={renewalPricing} size="small" />
          : <span className="font-semibold text-muted-foreground">{t('common.notAvailable')}</span>}
      </div>
      <p className="text-xs text-muted-foreground">
        {t('commercialPlanChange.downgrade.message', { date: formattedDate })}
      </p>
    </div>
  );
}
